import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { COMPANY, resolveUrl } from "@/lib/api";

export const SITE_URL = process.env.REACT_APP_BACKEND_URL;

export const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": ["Organization", "LocalBusiness"],
  "@id": `${SITE_URL}/#organization`,
  name: "Deliver Pty Ltd",
  alternateName: "Deliver",
  url: SITE_URL,
  description: "Sydney based gourmet food distributor, wholesale food supplier and high care food processor supplying independent supermarkets, grocers, delis, cafes, restaurants and foodservice businesses.",
  telephone: COMPANY.phone,
  email: COMPANY.email,
  address: { "@type": "PostalAddress", streetAddress: "39 Sunblest Crescent", addressLocality: "Mount Druitt", addressRegion: "NSW", postalCode: "2770", addressCountry: "AU" },
  areaServed: ["Sydney", "New South Wales", "Australian Capital Territory", "South East Queensland"],
  openingHoursSpecification: { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "06:00", closes: "16:00" },
  sameAs: [COMPANY.instagram],
};

export const Seo = ({ title, description, image, noindex = false, canonical, schema, type = "website" }) => {
  const { pathname } = useLocation();
  const fullTitle = title ? (title.includes("Deliver") ? title : `${title} | Deliver`) : "Deliver | Wholesale Food Distributor Sydney";
  const url = canonical || `${SITE_URL}${pathname}`;
  const img = image ? resolveUrl(image) : `${SITE_URL}/og-default.jpg`;
  const schemas = [ORG_SCHEMA, ...(Array.isArray(schema) ? schema : schema ? [schema] : [])];
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, follow" />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Deliver" />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="en_AU" />
      <meta name="twitter:card" content="summary_large_image" />
      {schemas.map((s, i) => <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>)}
    </Helmet>
  );
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.label, item: `${SITE_URL}${it.to}` })),
});
